import { render, staticRenderFns } from "./LicenseSubscriptionInfo.vue?vue&type=template&id=57b08c52&scoped=true"
import script from "./LicenseSubscriptionInfo.vue?vue&type=script&lang=js"
export * from "./LicenseSubscriptionInfo.vue?vue&type=script&lang=js"
import style0 from "./LicenseSubscriptionInfo.vue?vue&type=style&index=0&id=57b08c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b08c52",
  null
  
)

export default component.exports
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QMarkupTable,QItem,QItemSection,QIcon});
